//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from "assets/img/consent-logo.png";

import { consentStyles } from "./styles";
import auth from "apis/auth/auth";
import Loader from "components/Loader/CenteredLoader";
import { imageHandler } from "helpers/imageHandler";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";


// material-ui icons

export default function EnrollmentConsent() {
  const { getEnrollmentStatus, customerEnrollment, cancelEnrollment } = auth();
  const classes = consentStyles();
  const location = useLocation();

  const param = new URLSearchParams(location.search);
  const token = param.get("token");
  const gepFlag = param.get("gep");

  const [loading, setLoading] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [db, setDb] = useState("");
  const { t } = useTranslation();
  const [usLink, setusLink] = useState("");
  const [caLink, setcaLink] = useState("");
  const [frLink, setfrLink] = useState("");

  useEffect(() => {
    handleGetEnrollmentStatus();
  }, []);

  const handleGetEnrollmentStatus = async () => {
    try {
      setLoading(true);
      let res = await getEnrollmentStatus(token, gepFlag);
      if (res && res?.type == "success") {
        i18n.changeLanguage(res?.language);
        if (res?.redirectionURL) {
          setRedirectUrl(res?.redirectionURL);
        }
        setMessage(res.language == 'fr' ? res.french_message : res?.message);
        setStatus(res?.status);
        setusLink(res?.usLink)
        setcaLink(res?.caLink)
        setfrLink(res.frLink)
        setDb(res?.db);
        setLoading(false);
        return;
      }
      if (res && res?.message) {
        setMessage(res.language == 'fr' ? res.french_message : res?.message);
      } else {
        setMessage("Unauthorized");
      }
      setStatus("Unauthorized");
      setLoading(false);
    } catch (e) {
      console.log({ e });
    }
  };

  const handleCustomerEnrollment = async () => {
    try {
      let values = {
        token: token,
      };
      let res = await customerEnrollment(values, gepFlag);

      if (res && res?.type == "success") {
        setRedirectUrl(res?.redirectionURL);
        setMessage(res.language == 'fr' ? res.french_message : res?.message);
        setStatus("Processed");
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleCancelEnrollment = async () => {
    try {
      let values = {
        token: token,
      };
      let res = await cancelEnrollment(values, gepFlag);
      if (res && res?.type == "success") {
        let redirectionUrl;
        let referrerUrl = res?.referrerUrl;
        if (referrerUrl.includes("?")) {
          redirectionUrl = `${res?.referrerUrl}&shipto=${res?.encrypted}`;
        } else {
          redirectionUrl = `${res?.referrerUrl}?shipto=${res?.encrypted}`;
        }
        window.location.replace(redirectionUrl);
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <div className={classes.mainDiv}>
     {db && (
  <img
    src={
      imageHandler?.[db === "US" ? "Henry Schein Dental" : "Henry Schein Canada"]
        ?. [i18n?.language]
        ?. [db === "US" ? "Newheader" : "nullHeaderLogo"]
    }
    alt="logo"
    style={{ marginTop: 50, marginBottom: 50, width: 400 }}
  />
)}
      <Loader Loading={loading}>
        {status === "Inprocessed" && (
          <Card className={classes.card}>
            <div className={classes.divText}>{t("Acknowledgement")}</div>
            <div className={classes.divSubText}>
              {t("Thrive Rewards is a discount program intended for private dental practice and small group practices")}.{" "}
              {db == "US" ?
                t("For questions regarding eligibility, please contact Thrive Rewards Customer Service at 1-800-888-6684") :
                t("For questions regarding eligibility, please contact Thrive Rewards Customer Service at 1-800-668-5558")}.{" "}
              {t("By enrolling in Thrive Rewards, you have read, understood and agree to the")}{" "}
              {db == "US" ? <a
                target="_blank"
                href={usLink}
              >
                {t("[Terms & Conditions]")}
              </a> : i18n?.language == "fr" ? <a
                target="_blank"
                href={frLink}
              >
                {t("[Terms & Conditions]")}
              </a> : <a
                target="_blank"
                href={caLink}
              >
                {t("[Terms & Conditions]")}
              </a>}{" "}
              {t("of this program")}.
            </div>
            <Button
              className={classes.cancelBtn}
              onClick={() => {
                handleCancelEnrollment();
              }}
            >
              {t("Cancel Enrollment")}
            </Button>
            <Button
              className={classes.enrollBtn}
              onClick={() => {
                handleCustomerEnrollment();
              }}
            >
              {t("Enroll")}
            </Button>
          </Card>
        )}
        {status === "Processed" && (
          <div>
          <img
  src={
    imageHandler?.[db === "US" ? "Henry Schein Dental" : "Henry Schein Canada"]
      ?. [i18n?.language]
      ?. [db === "US" ? "NewCongrulations" : "congratulationLogo"]
  }
  alt=""
  width="50%"
/>
            <div className={classes.message}>{message}</div>
            <Button
              className={classes.goBackBtn}
              onClick={() => {
                window.location.replace(redirectUrl);
              }}
            >
              {t("Go Back")}
            </Button>
          </div>
        )}
        {status === "Unauthorized" && (
          <div>
            <div className={classes.message}>{message}</div>
          </div>
        )}
      </Loader>
    </div>
  );
}
